import * as Components from '../components'
import { View } from 'tamagui'
import { useRouter } from 'expo-router'
import { Routes } from '@/src/common/enums/routes'
import { useSardine } from '@/src/services/Sardine'
import { useEffect } from 'react'
import { useDisableSwipingBackToThePreviousPage } from '@/src/common/hooks/disableSwipingBackToThePreviousPage'

export function DeniedScreen() {
  const router = useRouter()
  const { updateOptions } = useSardine()

  useEffect(() => {
    void updateOptions({ flow: 'application-denied' })
  }, [updateOptions])

  useDisableSwipingBackToThePreviousPage()
  return (
    <View flex={1} bg="$white1" pb="$8">
      <Components.ApplicationScreen>
        <Components.ApplicationScreen.Content title="Your application is not approved at this time">
          <Components.FormHelpText>
            We are unable to approve your application at this time. We understand that this may not
            be the decision you were expecting. You will receive a notification from us advising you
            of the reasons for decline. Please try again in 30 days.
          </Components.FormHelpText>
        </Components.ApplicationScreen.Content>
        <Components.ApplicationScreen.SubmitButton
          onPress={() => router.replace(Routes.Main.route)}
          title="Return Home"
        />
      </Components.ApplicationScreen>
    </View>
  )
}
